@if (answer) {
  <div class="printAnswer">
    <div class="printAnswer-header">
      <div>
        <div class="printAnswer-title">
          {{ "global.lead" | translate }}
        </div>
        <div class="printAnswer-header__leadID">#{{ answer.id }}</div>
      </div>
      <div class="printAnswer-header__date">
        {{ answer.date | date: "dd.MM.y"
        }}<span> {{ answer.time }} ({{ answer.time_zone_short_value }})</span>
      </div>
    </div>
    <section class="leadData">
      <a [href]="answer.site_source" target="_blank">{{
        answer.site_source
      }}</a>
      <div>{{ answer.page_source }}</div>
      <a
        [href]="
          answer.site_source +
          answer.page_source.substring(1, answer.page_source.length)
        "
        target="_blank"
        >{{ answer.form_name }}</a
      >
    </section>
    <section class="fieldList">
      @for (
        field of answer.lead_data;
        track field.field_id + "-" + index;
        let index = $index
      ) {
        <app-field-value-item [data]="field" [forPrint]="true"></app-field-value-item>
      }
      <app-field-value-item [files]="answer.files"></app-field-value-item>
    </section>
  </div>
}
